import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { CategorieDocumentDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-categorie-document-select',
  templateUrl: './categorie-document-select.component.html',
  styleUrls: ['./categorie-document-select.component.css']
})
export class CategorieDocumentSelectComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.categoriesDocument$) categoriesDocument$: Observable<CategorieDocumentDto[]>;

  @Input('width') width: number;

  @Input() categorieDocumentId: number;
  @Output() categorieDocumentIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  CategoriesDocument: CategorieDocumentDto[] = [];

  cd: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
    }

  ngOnInit() {
    if(this.categorieDocumentId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.categorieDocumentId));
    }
    this.cd = this.categoriesDocument$.subscribe(res => {
      if (res != null) {
        this.CategoriesDocument = res;
      }
    });
  }

  ngOnDestroy() {
    this.cd?.unsubscribe();
  }

  updateInfo(event) {
    if (!!this.cell && this.InitId != this.categorieDocumentId) {
      this.cell.setValue(this.categorieDocumentId);
    }
    //this.categorieDocumentId = event.selectedItem != null ? event.selectedItem.Id : this.categorieDocumentId;
    this.categorieDocumentIdChange.emit(this.categorieDocumentId);
  }


}
